import React, { useCallback, useState } from "react";
import { useForwardAction } from "../../hooks/useCallAction";
import ForwardUI from "./ForwardUI";
import { useRouteConfigModals } from "../contexts/RouteConfigModalsContext";

/**
 * Forward component - can be used for root or off-hours contexts
 * @param {string} context - 'root' | 'offHours' (defaults to 'root')
 */
const Forward = ({ 
  setOpenConfigureSlotModal, 
  route, 
  setRoute,
  context = 'root',
  hasValidationError = false,
}) => {
  const routeModals = useRouteConfigModals();
  const [localChannels] = useState(
    () => JSON.parse(localStorage.getItem("organization"))?.channels?.L || []
  );
  const channels = routeModals?.channels ?? localChannels;
  const forwardLogic = useForwardAction(context, route, setRoute);

  // Resolve channel id to phone number so primaryNumber/offHoursNumber store phone in the DB
  const handleDestinationChange = useCallback(
    (value) => {
      const [channelId, phoneFromModal] = Array.isArray(value) ? value : [value, undefined];
      const phone = phoneFromModal ?? (() => {
        const ch = channels?.find((c) => (c.M?.ch_id?.S ?? c.ch_id) === channelId);
        return ch ? (ch.M?.value?.S ?? ch.value) : channelId;
      })();
      forwardLogic.handleNumberChange(phone);
    },
    [channels, forwardLogic.handleNumberChange]
  );

  const addDestinationOption = routeModals
    ? { label: "Add Forwarding Number", onClick: () => routeModals.openAddChannelModal("forward_number", handleDestinationChange) }
    : undefined;

  return (
    <ForwardUI
      {...forwardLogic}
      setOpenConfigureSlotModal={setOpenConfigureSlotModal}
      channels={channels}
      hasValidationError={hasValidationError}
      addDestinationOption={addDestinationOption}
      onDestinationChange={handleDestinationChange}
    />
  );
};

export default Forward;
